module.exports = __webpack_public_path__ + "static/media/matching-score-background.2c323c1f.jpg";